module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-breadcrumb/theme/lui-breadcrumbitem.global.scss
// module id = 176
// module chunks = 0 1 11